import { render } from "./ProductRegistrationList.vue?vue&type=template&id=72d86db2"
import script from "./ProductRegistrationList.vue?vue&type=script&lang=js"
export * from "./ProductRegistrationList.vue?vue&type=script&lang=js"

import "./ProductRegistrationList.vue?vue&type=style&index=0&id=72d86db2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__